/**
 * O navegador emite o erro "ResizeObserver loop completed with undelivered notifications"
 * quando uma callback de ResizeObserver altera o layout no mesmo frame em que foi entregue,
 * fazendo o observer gerar novas notificações que não cabem no ciclo atual.
 *
 * Bibliotecas que medem elementos durante interações caem nesse caso no Kanban é o
 * @dnd-kit, que remede as colunas quando a altura delas muda ao soltar um card.
 *
 * Adiar a callback para o próximo frame tira a alteração de layout do ciclo de entrega do
 * observer, o que elimina o aviso sem interceptar nem silenciar erros da aplicação.
 */
const NativeResizeObserver = window.ResizeObserver;

if (NativeResizeObserver) {
    const DeferredResizeObserver = function (callback) {
        return new NativeResizeObserver(function (entries, observer) {
            window.requestAnimationFrame(function () {
                callback(entries, observer);
            });
        });
    };

    DeferredResizeObserver.prototype = NativeResizeObserver.prototype;

    window.ResizeObserver = DeferredResizeObserver;
}
